import styled, { css } from 'styled-components/macro'
import { Z_INDEX } from 'theme/zIndex'

export const HideMedium = styled.div`
  @media (min-width: 1201px) {
    display: none;
  }
`
export const PageWrapper = styled.div`
  z-index: 1;
  padding: 0 16px;
  width: 100%;
  @media (min-width: 1201px) {
    max-width: 1440px;
  }

  @media only screen and (max-width: ${({ theme }) => `${theme.breakpoint.md}px`}) {
    padding-top: 48px;
  }

  @media only screen and (max-width: ${({ theme }) => `${theme.breakpoint.sm}px`}) {
    padding-top: 20px;
  }
`
// Mostly copied from `AppBody` but it was getting too hard to maintain backwards compatibility.
export const SwapWrapper = styled.main<{ chainId: number | undefined }>`
  position: relative;
  background: ${({ theme }) => theme.swapBackground};
  z-index: ${Z_INDEX.deprecated_content};
`
export const ArrowWrapper = styled.div<{ clickable: boolean }>`
  border-radius: 12px;
  height: 40px;
  width: 40px;
  position: absolute;
  border: 2px solid;
  border-color: ${({ theme }) => theme.swapTokensIconBorder};

  left: 50%;
  margin-top: 6px;
  transform: translate(-50%, -50%);

  z-index: 2;
  transition: scale 0.3s ease;

  ${({ clickable }) =>
    clickable
      ? css`
          :hover {
            cursor: pointer;
            scale: 1.025;
          }
        `
      : null}
`
export const MainWrapper = styled.div`
  padding-top: 24px;
  @media (min-width: 1201px) {
    padding-right: 50px;
  }
`
export const ArrowContainer = styled.div`
  display: inline-flex;
  align-items: center;
  justify-content: center;

  width: 100%;
  height: 100%;
  background: ${({ theme }) => theme.swapTokensIconBackground};
  border-radius: 10px;
`
export const DetailsSwapSection = styled.div`
  padding: 0;
  min-height: 44px;
  height: auto;
`
export const ContentWrapper = styled.div`
  width: 100%;
  display: grid;
  position: relative;
  grid-template-columns: 1fr auto 2fr;
  @media (max-width: 1200px) {
    grid-template-columns: 1fr;
  }
`
export const SwapSpacer = styled.div<{ vertical?: boolean }>`
  width: ${({ vertical }) => (!vertical ? '100%' : '1px')};
  height: ${({ vertical }) => (!vertical ? '1px' : '100%')};
  background: rgba(97, 105, 113, 0.2);
`
export const PriceChangeChartWrapper = styled.div`
  width: 100%;
  padding-bottom: 26px;
  @media (min-width: 1201px) {
    padding-left: 26px;
  }
`
export const ChartWrap = styled.div`
  display: grid;
  grid-template-rows: auto 1px 1fr;
  z-index: 1;
  @media (max-width: 1200px) {
    display: none;
    border: 1px solid ${({ theme }) => theme.swapFormInputBorder};
    border-radius: 12px 12px 0 0;
    box-shadow: 0px 2px 16px -4px rgba(45, 54, 67, 0.04), 0px 2px 4px -4px rgba(45, 54, 67, 0.04);
    &.show--mobile {
      top: 100px;
      left: -16px;
      right: -16px;
      display: grid;
      position: absolute;
      background: #1d222b;
      z-index: 99;
    }
  }
`
